import React, { useCallback, useEffect, useState } from "react";
import { getCkycAuthDocs } from "../../services/httpCalls";
import { Button, Modal, Table } from "antd";
import JsFileDownloader from "js-file-downloader";
import useNotify from "../../utils/useNotify";
import { useSetRecoilState } from "recoil";
import { showloader } from "../../store/gloabalState";
import { Box, Paper } from "@mui/material";
const ShowDocs = ({ email, pan }) => {
  const [open, setOpen] = useState(false);
  const notify = useNotify();
  const setShowLoader = useSetRecoilState(showloader);
  const [ckycDocs, setCkycDocs] = useState();
  const [authDocs, setAuthDocs] = useState();
  const [totalCountCkyc, setTotalCountCkyc] = useState(0);
  const [totalAuthCount, setTotalAuthCount] = useState(0);
  const handleOpen = async () => {
    setOpen(!open);
    await fetchDocs(email, pan);
  };
  const handleClose = () => {
    setOpen(!open);
  };

  const docsCols = [
    {
      title: "Name",
      dataIndex: "fileName",
      align: "center",
      ellipsis: true,
    },
    {
      title: "Type",
      dataIndex: "documentType",
      align: "center",
    },
    {
      title: "Download",
      align: "center",
      render: (record) => (
        <Button
          type="primary"
          onClick={() => {
            setShowLoader(true);
            new JsFileDownloader({
              url: record.presignedUrl,
            })
              .then((res) => {
                notify.success("Download Success!");
              })
              .catch((err) => {
                notify.error("Download Failed!");
              })
              .finally(() => {
                setShowLoader(false);
              });
          }}
        >
          Download
        </Button>
      ),
    },
  ];
  const authDocsCols = [
    {
      title: "Name",
      dataIndex: "fileName",
      align: "center",
      ellipsis: true,
    },
    {
      title: "Type",
      dataIndex: "documentType",
      align: "center",
    },
    {
      title: "Download",
      align: "center",
      render: (record) => (
        <Button
          type="primary"
          onClick={() => {
            setShowLoader(true);
            new JsFileDownloader({
              url: record.presignedUrl,
            })
              .then((res) => {
                notify.success("Download Success!");
              })
              .catch((err) => {
                notify.error("Download Failed!");
              })
              .finally(() => {
                setShowLoader(false);
              });
          }}
        >
          Download
        </Button>
      ),
    },
  ];

  const fetchDocs = async (email, pan) => {
    setShowLoader(true);
    await getCkycAuthDocs(email, pan)
      .then((res) => {
        setCkycDocs(res?.corporateKycDocs);
        setAuthDocs(res?.authorizedSignatoryDocs);
        setTotalCountCkyc(res?.corporateKycDocs?.length);
        setTotalAuthCount(res?.authorizedSignatoryDocs?.length);
        setShowLoader(false);
      })
      .catch((err) => {
        notify.error("Error fetching Documents!");
        setShowLoader(false);
      });
  };

  // useEffect(() => {
  //   if (open === true) fetchDocs(email, pan);
  // }, [open]);

  return (
    <div>
      <Button type="primary" onClick={handleOpen} size="small">
        Show Docs
      </Button>
      <Modal
        title={<h5>{`Documents | PAN: ${pan} | EMAIL: ${email}`}</h5>}
        open={open}
        onCancel={handleClose}
        footer={null}
        width={1000}
      >
        <p style={{}}>Corporate Docs</p>
        <Box component={Paper}>
          <Table
            columns={docsCols}
            dataSource={ckycDocs}
            className="styledAntd"
            pagination={{
              total: totalCountCkyc,
              showSizeChanger: false,
              pageSize: 5,
              position: ["bottomCenter"],
            }}
          />
        </Box>
        <p
          style={{
            marginTop: "0.5rem",
          }}
        >
          Authorized Signatories Docs
        </p>
        <Box
          component={Paper}
          sx={{
            marginTop: "0.5rem",
          }}
        >
          <Table
            columns={authDocsCols}
            dataSource={authDocs}
            className="styledAntd"
            pagination={{
              total: totalAuthCount,
              showSizeChanger: false,
              pageSize: 6,
              position: ["bottomCenter"],
            }}
          />
        </Box>
      </Modal>
    </div>
  );
};

export default React.memo(ShowDocs);
